<div class="entsorger-details-page" [class.entsorger-details-page--dialog]="showAsDialog">
    <ng-container *ngIf="!showAsDialog && isMobileScreen; else defaultHeader">
        <div class="entsorger-details-header-mobile">
            <button mat-icon-button color="accent" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="entsorger-details-header-mobile__title">{{ entsorger ? entsorger.name : 'Entsorger anlegen' }}</h3>
        </div>
    </ng-container>
    <ng-template #defaultHeader>
        <kiene-page-header
            *ngIf="!showAsDialog"
            [routeRelativeAlternative]="backRoute"
            [ueberschrift]="entsorger ? entsorger.name : 'Entsorger anlegen'"
        ></kiene-page-header>
    </ng-template>

    <button
        *ngIf="entsorger?.favorit && !showAsDialog"
        (click)="deleteEntsorgerFavorit($event)"
        color="warn"
        mat-flat-button
        style="margin: 12px 0 12px 0"
        type="button"
    >
        <mat-icon>delete</mat-icon>
        Entsorger&nbsp;entfernen
    </button>

    <div style="width: 100%">
        <kiene-autocomplete
            #nameAutocomplete
            (elementSelected)="selectedEntsorger($event)"
            *ngIf="!entsorger?.entsorger_id"
            [displayFields]="['name', 'ort']"
            [separator]="', '"
            [emitFreeText]="false"
            [createNewAllowed]="true"
            [createNewText]="'Entsorger anlegen'"
            (createNew)="createNewEntsorger($event)"
            [focus]="false"
            [genericApiUrl]="entsorgerPath"
            [placeholder]="'Name'"
            [required]="true"
            [showClear]="false"
            [showLoadingIndicator]="true"
        >
        </kiene-autocomplete>
    </div>

    <div *ngIf="entsorger" class="entsorger-edit-form">
        <mat-form-field class="entsorger-form-input">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="entsorger.name" placeholder="Name" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>VVVO</mat-label>
            <input matInput [(ngModel)]="entsorger.vvvo" placeholder="VVVO" maxlength="15" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>E-Mail Adresse</mat-label>
            <input matInput [(ngModel)]="entsorger.email" placeholder="E-Mail Adresse" type="email" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>Telefon</mat-label>
            <input matInput [(ngModel)]="entsorger.telefon" placeholder="Telefon" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>Mobil</mat-label>
            <input matInput [(ngModel)]="entsorger.mobil" placeholder="Mobil" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>FAX</mat-label>
            <input matInput [(ngModel)]="entsorger.fax" placeholder="FAX" />
        </mat-form-field>

        <mat-form-field class="entsorger-form-input">
            <mat-label>Straße und Nr.</mat-label>
            <input matInput [(ngModel)]="entsorger.strasse" placeholder="Straße und Nr." />
        </mat-form-field>

        <div class="one-row">
            <mat-form-field class="entsorger-form-input form-col">
                <mat-label>PLZ</mat-label>
                <input matInput [(ngModel)]="entsorger.plz" placeholder="PLZ" />
            </mat-form-field>
            <mat-form-field class="entsorger-form-input form-col">
                <mat-label>Ort</mat-label>
                <input matInput [(ngModel)]="entsorger.ort" placeholder="Ort" />
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="entsorger?.kundenNrVvvos?.length > 0">
        <h3>Kundennummern pro VVVO</h3>
        <div style="margin: 6px 0 12px 0">
            <mat-hint class="hinweis-text">
                <span>
                    <strong>Hinweis:&nbsp;</strong>
                    Bitte pro VVVO die Kundennr. für den Entsorger angegeben, sonst kann später keine Todmeldung
                    getätigt werden.
                </span>
            </mat-hint>
        </div>

        <mat-card *ngFor="let zuordnung of entsorger?.kundenNrVvvos" style="margin-bottom: 6px; padding: 12px">
            <h3 style="margin-block: 0">
                {{ zuordnung.vvvo || 'Keine VVVO' }}
                <span *ngIf="zuordnung.betrieb" class="hinweis-text" style="font-weight: normal; font-size: 0.9em">
                    – {{ zuordnung.betrieb }}<ng-container *ngIf="zuordnung.betrieb_zusatz"> ({{ zuordnung.betrieb_zusatz }})</ng-container>
                </span>
            </h3>
            <mat-form-field class="no-padding-margin-mat-form-field" style="width: 100%">
                <input [(ngModel)]="zuordnung.kunden_nr" matInput placeholder="Kundennummer" />
            </mat-form-field>
        </mat-card>
    </div>

    <div
        [style]="showAsDialog ? 'position: sticky; bottom: 0; background-color: white; padding: 12px 0;' : ''"
        class="one-row"
    >
        <span *ngIf="!showAsDialog" class="spacer"></span>
        <button (click)="addOrUpdateEntsorger()" [disabled]="isLoading" color="accent" mat-flat-button
            >Speichern
        </button>
        <span class="spacer"></span>
        <ng-content select="[additional-actions]"></ng-content>
    </div>
</div>
